<template>
      <span>{{this.currentEtichetta}}</span>
</template>

<script>
export default {
  name: "etichetta",
  props: ['etichetta'],
  data:function () {
    return {
      currentEtichetta: null,
    }
  },
  mounted() {
    this.getEtichetta()
  },
  methods: {
    getEtichetta :function () {
      let pathname = window.location.pathname.split('/');
      let cod_category = pathname[pathname.length - 2];
      let color = pathname[pathname.length - 1]

      axios({
        method: 'get',
        url: window.location.origin + '/data/get-family',
        params: {
          cod: this.etichetta,
          type: 'etichetta',
        }
      })
          .then(res => {

            this.currentEtichetta = res.data.family.descrizione


          })
          .catch(err => {


            this.$store.commit('add_message', {
              type: 'error',
              message: err.response.data.message
            })

          })
    }
  },
}
</script>

<style scoped>

</style>